import fa from './fa/fa.json'

const messages = {
  fa: { ...fa },
}

export default messages
